import React, { useState } from 'react';
import { ChevronRight, Users, Sparkles, Clock } from 'lucide-react';
import EmailForm from './EmailForm';
import AnimatedContactCard from './AnimatedContactCard';
import SuccessMessage from './SuccessMessage';

const Hero = () => {
  const [showSuccess, setShowSuccess] = useState(false);

  return (
    <section className="relative min-h-screen bg-gradient-to-br from-blue-50/50 via-white to-indigo-50/50 flex items-center justify-center overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Content */}
          <div className="text-center lg:text-left">
            <div className="inline-flex items-center bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-medium mb-6">
              <Sparkles className="w-4 h-4 mr-2" />
              Join 12,847+ professionals already waiting
            </div>
            
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600 leading-tight mb-4">
              ContaX
            </h1>
            
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-gray-800 leading-tight mb-6">
              Never Forget Who You Met
            </h2>
            
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Transform every networking event into lasting professional relationships. 
              ContaX helps you remember, organize, and nurture the connections that matter most.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <div className="flex items-center text-gray-700">
                <Users className="w-5 h-5 mr-2 text-blue-600" />
                <span>Smart contact management</span>
              </div>
              <div className="flex items-center text-gray-700">
                <ChevronRight className="w-5 h-5 mr-2 text-blue-600" />
                <span>Context-first networking</span>
              </div>
              <div className="flex items-center text-gray-700">
                <Clock className="w-5 h-5 mr-2 text-blue-600" />
                <span>Timely follow-up</span>
              </div>
            </div>

            {!showSuccess && (
              <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-lg">
                <EmailForm onSuccess={() => setShowSuccess(true)} />
              </div>
            )}

            {showSuccess && (
              <SuccessMessage />
            )}
          </div>

          {/* Right Column - Animated Visual */}
          <div className="relative">
            <AnimatedContactCard />
            <div className="absolute -bottom-4 -right-4 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-xl p-4 text-white shadow-xl backdrop-blur-sm">
              <div className="text-2xl font-bold">847</div>
              <div className="text-sm opacity-90">Connections</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;